var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSessionHasIssues = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 28,
    cy: 28.0001,
    r: 28,
    fill: "#BF1722"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 28,
    cy: 28.0001,
    r: 22,
    fill: "#BF1722"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28.0001,
    r: 16,
    fill: "#BF1722"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5909 28L34.0441 23.5469C34.2554 23.3359 34.3743 23.0496 34.3745 22.751C34.3748 22.4524 34.2564 22.1659 34.0455 21.9545C33.8345 21.7432 33.5482 21.6243 33.2496 21.624C32.951 21.6238 32.6645 21.7422 32.4531 21.9531L28 26.4062L23.5469 21.9531C23.3355 21.7418 23.0489 21.623 22.75 21.623C22.4511 21.623 22.1645 21.7418 21.9531 21.9531C21.7418 22.1645 21.623 22.4511 21.623 22.75C21.623 23.0489 21.7418 23.3355 21.9531 23.5469L26.4062 28L21.9531 32.4531C21.7418 32.6645 21.623 32.9511 21.623 33.25C21.623 33.5489 21.7418 33.8355 21.9531 34.0469C22.1645 34.2582 22.4511 34.3769 22.75 34.3769C23.0489 34.3769 23.3355 34.2582 23.5469 34.0469L28 29.5937L32.4531 34.0469C32.6645 34.2582 32.9511 34.3769 33.25 34.3769C33.5489 34.3769 33.8355 34.2582 34.0469 34.0469C34.2582 33.8355 34.3769 33.5489 34.3769 33.25C34.3769 32.9511 34.2582 32.6645 34.0469 32.4531L29.5909 28Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSessionHasIssues);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/session-has-issues.6f57b1dbeff453e330456bba0a0143ae.svg";